import './type-row.styl'
import React from 'react'
import { Row, Col } from 'react-bootstrap'


class Component extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    let { type, click, active } = this.props

    if (typeof click !== 'function') {
      click = () => {}
    }

    let classNames = 'type-row'

    if (type.disabled) {
      classNames += ' disabled'
    }

    if (!type.disabled && active) {
      classNames += ' active'
    }

    return (
      <div className={classNames} onClick={ (e) => { click(e) } }>
        <Row>
          <Col xs={9}>{ type.name }</Col>
          <Col xs={3} className="align-right"><i className="fa fa-chevron-right" /></Col>
        </Row>
      </div>
    )
  }
}

export default Component



// WEBPACK FOOTER //
// ./components/Types/type-row.js